export enum CookiesEnum {
    all = 'all',
    technical = 'technical',
    analytics = 'analytics',
    marketing = 'marketing'
}